import { APP_CONSTANTS } from "../../core/config/appConstants";

const TAB_ID_KEY = "tab_id";

const getOrCreateTabId = () => {
	let tabId = sessionStorage.getItem(TAB_ID_KEY);
	if (!tabId) {
		tabId = crypto.randomUUID();
		sessionStorage.setItem(TAB_ID_KEY, tabId);
	}
	return tabId;
};

const setCookie = (key, value, minutes = APP_CONSTANTS.SESSION_DURATION) => {
	const tabId = getOrCreateTabId();
	const expires = new Date(
		Date.now() + minutes * 60 * 1000
	).toUTCString();
	const cookieName = `${tabId}_${key}`;
	document.cookie = `${cookieName}=${encodeURIComponent(
		value
	)}; expires=${expires}; path=/; SameSite=Strict; Secure`;
};

const getCookie = (key) => {
	const tabId = getOrCreateTabId();
	const cookieName = `${tabId}_${key}`;
	const cookies = document.cookie.split("; ");
	for (const cookie of cookies) {
		const [name, value] = cookie.split("=");
		if (name === cookieName) {
			return decodeURIComponent(value);
		}
	}
	return null;
};

const removeCookie = (key) => {
	const tabId = getOrCreateTabId();
	const cookieName = `${tabId}_${key}`;
	document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict; Secure`;
};

const CookieUtils = {
	setCookie,
	getCookie,
	removeCookie
};

export default CookieUtils;
